import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router";
import axios from 'axios';

import { AppContext } from '../../../../context.js';
import { ChevronUp, ChevronDown } from "../../../../files/icons/index.js";

import Loading from '../../../components/loading.js';
import Helmet from "../../../components/helmet.js";

function ProjectsStatistics() {
  const context = useContext(AppContext);

  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [statistics, setStatistics] = useState([]);
  const [expandedGroups, setExpandedGroups] = useState([]);

  useEffect(() => {
    let u = context.addSpiner();
    axios.post('/api/admin/analytics/projects/statistics', {})
      .then((response) => {
        setStatistics(response.data);
        setLoading(false);
      })
      .catch((e) => {
        context.addError(e);
        context.removeSpiner(u);
      })
      .finally(() => {
        context.removeSpiner(u);
      });
  }, []);

  function toggleGroup(groupTitle) {
    if (expandedGroups.includes(groupTitle)) {
      setExpandedGroups(expandedGroups.filter(title => title !== groupTitle));
    } else {
      setExpandedGroups([...expandedGroups, groupTitle]);
    }
  }

  function renderTemplateDetails(templates) {
    return templates.map((template, index) => {
      return (
        <div
          key={index}
          className={"card-header clickable sm " + (templates.length === index + 1 ? "last" : "")}
          onClick={() => navigate(`/projects?templateID=${template.id}`)}
        >
          <div className="row">
            <div className="col-xs-4">
              <div className="typo-strong-150">{template.title}</div>
            </div>
            <div className="col-xs-8">
              <div className="row">
                <div className="col-xs-2 text-center">
                  <div className="typo-strong-150">{template.total}</div>
                </div>
                <div className="col-xs-2 text-center">
                  <div className="typo-normal-150">{template.toDo}</div>
                </div>
                <div className="col-xs-2 text-center">
                  <div className="typo-normal-150">{template.inProgress}</div>
                </div>
                <div className="col-xs-2 text-center">
                  <div className="typo-normal-150">{template.paused}</div>
                </div>
                <div className="col-xs-2 text-center">
                  <div className="typo-normal-150">{template.completed}</div>
                </div>
                <div className="col-xs-2 text-center">
                  <div className="typo-normal-150">{template.canceled}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  }

  function renderGroups() {
    if (!statistics || statistics.length === 0) {
      return (
        <div className="card mb-2">
          <div className="card-header sm">
            <div className="typo-normal-150">No project groups available.</div>
          </div>
        </div>
      );
    }

    return statistics.map((group, index) => {
      const isExpanded = expandedGroups.includes(group.title);

      return (
        <div key={index} className="card mb-2">
          <div className="card-header clickable sm" onClick={() => toggleGroup(group.title)}>
            <div className="row">
              <div className="col-xs-4">
                <div className="typo-strong-175">{group.title}</div>
              </div>
              <div className="col-xs-8">
                <div className="row">
                  <div className="col-xs-2 text-center">
                    <div className="typo-strong-175">{group.total}</div>
                  </div>
                  <div className="col-xs-2 text-center">
                    <div className="typo-strong-175">{group.toDo}</div>
                  </div>
                  <div className="col-xs-2 text-center">
                    <div className="typo-strong-175">{group.inProgress}</div>
                  </div>
                  <div className="col-xs-2 text-center">
                    <div className="typo-strong-175">{group.paused}</div>
                  </div>
                  <div className="col-xs-2 text-center">
                    <div className="typo-strong-175">{group.completed}</div>
                  </div>
                  <div className="col-xs-2 text-center">
                    <div className="typo-strong-175">{group.canceled}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {isExpanded && renderTemplateDetails(group.templates)}
        </div>
      );
    });
  }

  if (loading) {
    return (
      <>
        <Helmet title="Analytics | Project Analytics Dashboard" />
        <Loading />
      </>
    );
  }

  return (
    <>
      <Helmet title="Analytics | Project Analytics Dashboard" />

      <div className="container">
        <div className="row mb-4">
          <div className="col-xs-12">
            <div className="d-flex justify-content-between align-items-center">
              <div className="">
                <div className="typo-hero-small">Project Analytics Dashboard</div>
                <div className="typo-normal-175">Program-wide tracking of care coordination projects by payment tier and completion status. Monitor workflow efficiency and identify bottlenecks across all GUIDE Model service categories</div>
              </div>
              <div className="w-25 text-end">
                {/* <div className="item typo-normal-150 ms-2" onClick={() => navigate('/patient/create')}><FilePlus height={16} width={16} color={'grey'} /> Create Patient</div> */}
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">

            <div className="card mb-2">
              <div className="card-header sm">
                <div className="row">
                  <div className="col-xs-4">
                    <div className="typo-strong-150">Group / Template</div>
                  </div>
                  <div className="col-xs-8">
                    <div className="row">
                      <div className="col-xs-2 text-center">
                        <div className="typo-strong-150">Total</div>
                      </div>
                      <div className="col-xs-2 text-center">
                        <div className="typo-strong-150">To Do</div>
                      </div>
                      <div className="col-xs-2 text-center">
                        <div className="typo-strong-150">In Progress</div>
                      </div>
                      <div className="col-xs-2 text-center">
                        <div className="typo-strong-150">Paused</div>
                      </div>
                      <div className="col-xs-2 text-center">
                        <div className="typo-strong-150">Completed</div>
                      </div>
                      <div className="col-xs-2 text-center">
                        <div className="typo-strong-150">Canceled</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {renderGroups()}

          </div>
        </div>
      </div>
    </>
  );
}

export default ProjectsStatistics;
